import { BezierLine } from '@model-framework/link/BezierLine/BezierLine';
import { Point } from '@view-model/models/common/basic';

export class ConsistencyLinkPlacement {
  public readonly fromPosition: Point;
  public readonly toPosition: Point;

  constructor(fromPosition: Point, toPosition: Point) {
    this.fromPosition = fromPosition;
    this.toPosition = toPosition;
  }

  bezierLine(): BezierLine {
    // TODO: 現時点では、中間点は中点固定（曲線ではなく、必ず直線）にする
    //       今後、View間のリンクも曲線対応する場合は、Node間リンクの実装を
    //       参考にして修正する必要がある
    const midPoint = this.midPoint(this.fromPosition, this.toPosition);
    return new BezierLine(this.fromPosition, midPoint, this.toPosition);
  }

  private midPoint(from: Point, to: Point): Point {
    const added = from.add(to);

    return new Point(added.x / 2, added.y / 2);
  }
}
